import { motion } from "framer-motion";
import { BRAND, SOCIALS, LISTEN } from "../data/content";
import { scrollToId } from "../hooks/useLenis";
import { ArrowUp } from "lucide-react";
import SocialBar from "./SocialBar";
import BrandIcon from "./BrandIcons";

export default function Footer() {
  const follow = SOCIALS.filter((s) => !["spotify", "apple"].includes(s.icon));

  return (
    <footer className="relative w-full pt-24 md:pt-32 pb-10 px-5 md:px-10 border-t border-white/10 bg-[color:var(--void)]" data-testid="footer">
      <div className="max-w-[1400px] mx-auto">
        {/* oversized wordmark */}
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="font-display chrome-text text-center text-[16vw] md:text-[12vw] leading-[0.85] tracking-[0.02em] mb-4 pointer-events-none"
        >
          {BRAND.name}
        </motion.h2>
        <p className="text-center font-display italic steel-text text-xl md:text-2xl mb-16">{BRAND.phrase}</p>

        <div className="grid md:grid-cols-3 gap-12 md:gap-8 pb-14 border-b border-white/10">
          <div>
            <p className="track-label text-white/40 mb-5">FOLLOW</p>
            <ul className="space-y-2.5">
              {follow.map((s) => (
                <li key={s.icon}>
                  <a
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`footer-social-${s.icon}`}
                    className="font-body text-white/60 hover:text-white transition-colors duration-300 text-sm inline-flex items-center gap-3 group"
                  >
                    <BrandIcon name={s.icon} size={16} className="text-white/50 group-hover:text-white transition-colors" />
                    {s.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="track-label text-white/40 mb-5">LISTEN</p>
            <ul className="space-y-2.5">
              {LISTEN.map((l) => (
                <li key={l.key}>
                  <a
                    href={l.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`footer-listen-${l.key}`}
                    className="font-body text-white/60 hover:text-white transition-colors duration-300 text-sm inline-flex items-center gap-3 group"
                  >
                    <BrandIcon name={l.icon} size={16} className="text-white/50 group-hover:text-white transition-colors" />
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:text-right flex md:block flex-col justify-between">
            <div>
              <p className="font-display chrome-text text-2xl md:text-3xl leading-none">{BRAND.name}</p>
              <p className="track-label text-white/40 mt-3">{BRAND.phrase}</p>
              <div className="mt-6 md:flex md:justify-end">
                <SocialBar size={20} gap="gap-4" />
              </div>
            </div>
            <button
              onClick={() => scrollToId("hero")}
              data-testid="footer-top"
              data-cursor
              className="mt-8 md:ml-auto inline-flex items-center gap-2 track-label text-white/50 hover:text-white transition-colors group"
            >
              BACK TO TOP
              <ArrowUp size={14} className="group-hover:-translate-y-1 transition-transform" />
            </button>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8">
          <p className="track-label text-white/30">{BRAND.copyright}</p>
          <p className="track-label text-white/30">{BRAND.phrase}</p>
          <p className="track-label text-white/30">ALL RIGHTS RESERVED</p>
        </div>
      </div>
    </footer>
  );
}
